"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementSeconds = exports.incrementMinutes = exports.incrementHours = void 0;
var time_1 = require("../../types/record/time");
var incrementHours = function (time) {
    return time.update('hours', function (x) { return (x + 1); });
};
exports.incrementHours = incrementHours;
var incrementMinutes = function (time) {
    return time.minutes === 59
        ? (0, exports.incrementHours)((0, time_1.ITime)({
            hours: time.hours,
            minutes: 0,
            seconds: time.seconds
        }))
        : time.update('minutes', function (x) { return (x + 1); });
};
exports.incrementMinutes = incrementMinutes;
var incrementSeconds = function (time) {
    return time.seconds === 59
        ? (0, exports.incrementMinutes)((0, time_1.ITime)({
            hours: time.hours,
            minutes: time.minutes,
            seconds: 0
        }))
        : time.update('seconds', function (x) { return (x + 1); });
};
exports.incrementSeconds = incrementSeconds;
